import React, { useEffect, useState } from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import toast from "react-hot-toast";
import CryptoJS from "crypto-js";
import bcrypt from "bcryptjs";
import { Spinner } from "react-bootstrap";
import PopUp from "../popup";
const Checkoutcartdetails = ({
  totalPrice,
  totalQuantity,
  language,
  cart,
  total_check,
  getUserData,
  getMe,
}) => {
  const [rerender, setRerender] = useState(false);

  const localData = localStorage.getItem("discount_coupon");
  const decryptedBytes = localData && CryptoJS.AES.decrypt(localData, "111");

  const discount =
    decryptedBytes && JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));

  const navigate = useNavigate();
  const [promoCode, setPromoCode] = useState("");
  const [promoLoading, setPromoLoading] = useState(false);

  useEffect(() => {
    ;
  }, rerender);

  const renderPage = () => {
    setRerender(!rerender);
  };

  const handleMakeDiscount = () => {
    setPromoLoading(true);
    const data_send = {
      code: promoCode,
    };

    ;
    // return
    Axios({
      url: BASE_URL + "coupons/use_coupon",
      method: "post",
      data: data_send,
    })
      .then((res) => {
        if (res.message == "Sission Ended Login Again") {
          toast.error(res.message);
        };

        if (res.status == "success") {
          ;
          const localData = localStorage.getItem("discount_coupon");
          const decryptedBytes =
            localData && CryptoJS.AES.decrypt(localData, "111");
          const discount =
            decryptedBytes &&
            JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));

          const discountValue =
            res.result.type == "percentage"
              ? (+res.result.val / 100) * total_check
              : +res.result.val;

          if (+discountValue < +total_check) {
            if (discount == null) {
              ;
              // let pushedData=bcrypt.hashSync(JSON.stringify({first_name:'abdu',last_name:'ali',email:'aa032@gmail.com'}),"$2a$10$CwTycUXWue0Thq9StjUM0u");
              let obj = {
                discount: res.result,
              };
              const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify(obj),
                "111"
              ).toString();
              localStorage.setItem("discount_coupon", encryptedData);
              toast.success(
                language == "ar"
                  ? "تم الخصم بنجاح"
                  : "You get discount successfully"
              );
            } else {
              toast.success(
                language == "ar"
                  ? "يتم خصم من كوبون واحد فقط"
                  : "Discount is from one coupon"
              );

              // toast.error(language=='ar'?'يتم الخصم مره واحده على الطلب':'for each order There Are One Try to make dicount')
              let new_dis = res.result;
              let obj = {
                discount: new_dis,
              };
              const encryptedData2 = CryptoJS.AES.encrypt(
                JSON.stringify(obj),
                "111"
              ).toString();
              localStorage.setItem("discount_coupon", encryptedData2);
              renderPage();
            }
          } else {
            toast.error(
              language == "ar"
                ? "قيمه الخصم اكبر من المبلغ الكلى"
                : "Discount Value Is More Than Total Price"
            );
          }
          // getUserData()
          getMe();
          renderPage();
        } else {
          toast.error(res.message);
        }
      })
      .finally(() => {
        setPromoLoading(false);
        renderPage();
      });
  };

  const handleDisableCoupon = () => {
    localStorage.removeItem("discount_coupon");
    setPromoCode("");
    renderPage();
  };

  const [paylogin, setPaylogin] = useState({
    payloginModal: false,
    username: "",
    userphone: "",
  });

  useEffect(() => {
    const localUserData = JSON.parse(localStorage.getItem("userPayInfo"));
    if (localUserData) {
      setPaylogin({
        ...paylogin,
        ...localUserData,
      });
      return;
    }
  }, []);

  // m_sayed functions

  const onPay = () => {
    const isThereIsToken = localStorage.getItem("GreenTreesToken");
    const isThereUserPayInfo = localStorage.getItem("userPayInfo");
    if (isThereIsToken || isThereUserPayInfo) {
      navigate("/pay-details");
      return;
    }
    setPaylogin({
      ...paylogin,
      payloginModal: true,
    });
  };

  const handleCompletePayment = () => {
    const dataset = {
      username: paylogin?.username,
      userphone: paylogin?.userphone,
    };
    localStorage.setItem("userPayInfo", JSON.stringify(dataset));
    navigate("/pay-details");
  };

  return (
    <div className="checkoutcartdetails">
      <div className="allPrice">
        <span>{language == "ar" ? "الإجمالي" : "Total"}</span>
        <span>
          {" "}
          {total_check}
          {language == "ar" ? "د.إ" : "AED"}
        </span>
      </div>
      <div className="allPrice my-2">
        <span>{language == "ar" ? "الخصم" : "Discount"}</span>
        {/* {} */}
        <span>
          <span>
            {/* {alert(discount?.discount?.val)} */}
            {discount
              ? discount?.discount?.type == "percentage"
                ? (discount?.discount?.val / 100) * total_check
                : discount?.discount?.val
              : 0}
          </span>
          <span>{language == "ar" ? "د.إ" : "AED"}</span>
        </span>
      </div>
      <p>
        {language == "ar"
          ? "غير شامل رسوم التوصيل"
          : "Delivery fees not included"}
      </p>
      <input
        onChange={(e) => {
          setPromoCode(e.target.value);
        }}
        type="text"
        value={promoCode}
        className="copounDesign"
        placeholder={language == "ar" ? "أضف البروموكود" : "Add Promo Code"}
      />
      {promoLoading ? (
        <Spinner />
      ) : !discount ? (
        <button
          onClick={() => {
            handleMakeDiscount();
          }}
          className="btn btn-success mb-4"
        >
          {language == "ar" ? "تفعيل الكوبون" : "Activate Copoun"}
        </button>
      ) : (
        <button
          onClick={() => {
            handleDisableCoupon();
          }}
          className="btn btn-danger mb-4"
        >
          {language == "ar" ? "حذف الكوبون" : " Disable Copoun"}
        </button>
      )}
      <button className="cartPay" onClick={() => onPay()}>
        {language == "ar" ? "الدفع" : "Pay"}
      </button>

      <PopUp
        solidOverLay={true}
        open={paylogin.payloginModal}
        title={
          language == "ar"
            ? "التسجيل لعملية الدفع"
            : "Rejesteration for payment"
        }
        setOpen={() => {
          setPaylogin({
            ...paylogin,
            payloginModal: false,
          });
        }}
        children={
          <>
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                return handleCompletePayment();
              }}
              className="d-flex flex-column gap-3"
            >
              <div className="my-3">
                <label htmlFor="phone my-2">
                  {language == "ar" ? "اسم المستخدم" : "username"}
                  <span className="star">*</span>
                </label>
                <input
                  placeholder={
                    language == "ar" ? "أدخل اسم المستخدم" : "Enter username"
                  }
                  type="text"
                  required
                  className="form-control py-3"
                  style={{
                    paddingBlock: "10px",
                  }}
                  name="username"
                  id="username"
                  onChange={(e) =>
                    setPaylogin({
                      ...paylogin,
                      username: e.target.value,
                    })
                  }
                />
              </div>
              <div className="my-3">
                <label htmlFor="phone my-2">
                  {language == "ar" ? "رقم الهاتف" : "Phone Number"}
                  <span className="star">*</span>
                </label>
                <input
                  placeholder={
                    language == "ar" ? "أدخل رقم الهاتف" : "Enter Your Phone"
                  }
                  required
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control py-3"
                  name="phone"
                  style={{
                    paddingBlock: "10px",
                  }}
                  id="phone"
                  onChange={(e) =>
                    setPaylogin({
                      ...paylogin,
                      userphone: e.target.value,
                    })
                  }
                />
              </div>
              <button className="payment-rejestration-button">
                {language == "ar" ? "متابعة" : "Continue"}
              </button>
            </form>
          </>
        }
      />
    </div>
  );
};

export default Checkoutcartdetails;
